<template>
  <div id="app" class="mapping-wrapper">
    <!-- Loading & Snackbar -->
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card flat class="mapping-card">
      <!-- ================== TABS ================== -->
      <v-tabs
        v-model="activeTab"
        color="info"
        dark
        slider-color="yellow"
      >
        <v-tab>Eşleştir</v-tab>
        <v-tab>Eşleştirilen Oteller</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">

        <!-- ============== TAB 0: OTEL EŞLEŞTİR ============== -->
        <v-tab-item>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-toolbar flat dark color="info" class="mapping-toolbar">
                <v-toolbar-title class="mapping-title">
                  Otel Mapping (Otel Eşleştir)
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-flex>

            <v-flex xs12 sm12>
              <v-container fluid class="mt-4">
                <v-card flat class="inner-card">
                  <v-card-title primary-title>
                    <span class="title font-weight-bold">Arkman Mapping Otel</span>
                  </v-card-title>

                  <v-card-text>
                    <v-layout row wrap>

                      <!-- ========= ARKMAN (Ratehawk) TARAFI ========= -->
                      <v-flex xs12 sm6 class="column-card">
                        <v-card flat>
                          <v-subheader class="column-header">Arkman Mapping Otel Arama</v-subheader>

                          <v-layout row wrap align-center class="search-row">
                            <v-flex xs9>
                              <v-text-field
                                label="Arkman Mapping Otel Adı"
                                v-model="arkmanMapping.ratehawk.searchText"
                                hide-details
                                class="search-input"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs3 class="search-button-wrap">
                              <v-btn
                                class="search-button"
                                color="info"
                                :loading="arkmanMapping.ratehawk.loading"
                                @click="searchRatehawk"
                                block
                              >
                                <v-icon left>search</v-icon> Ara
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <!-- Seçili otel özeti -->
                          <div v-if="arkmanMapping.ratehawk.selected" class="selected-summary">
                            Seçilen Arkman Mapping Otel:
                            <span class="selected-summary-name">
                              {{ arkmanMapping.ratehawk.selected.Name }}
                            </span>
                          </div>

                          <!-- Sonuç listesi -->
                          <v-slide-y-transition>
                            <div v-if="showRatehawkList && ratehawkPaged.length" class="list-wrapper">
                              <v-list dense>
                                <v-list-tile
                                  v-for="h in ratehawkPaged"
                                  :key="h.Id"
                                  @click="selectRatehawkHotel(h)"
                                  :class="[
                                    'hotel-item',
                                    {
                                      'hotel-item--selected':
                                        arkmanMapping.ratehawk.selected &&
                                        arkmanMapping.ratehawk.selected.Id === h.Id
                                    }
                                  ]"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title>{{ h.Name }}</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>

                              <!-- Pagination -->
                              <v-layout row justify-space-between align-center class="pagination-row">
                                <span class="page-info">
                                  {{ ratehawkPage }} / {{ ratehawkMaxPage }}
                                </span>
                                <v-btn
                                  small
                                  flat
                                  class="next-button"
                                  @click="nextRatehawkPage"
                                  :disabled="ratehawkPage >= ratehawkMaxPage"
                                >
                                  İleri
                                  <v-icon right small>chevron_right</v-icon>
                                </v-btn>
                              </v-layout>
                            </div>
                          </v-slide-y-transition>
                        </v-card>
                      </v-flex>

                      <!-- ========= COPER TARAFI ========= -->
                      <v-flex xs12 sm6 class="column-card">
                        <v-card flat>
                          <v-subheader class="column-header">Coper Otel Arama</v-subheader>

                          <v-layout row wrap align-center class="search-row">
                            <v-flex xs9>
                              <v-text-field
                                label="Coper Otel Adı"
                                v-model="arkmanMapping.coper.searchText"
                                hide-details
                                class="search-input"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs3 class="search-button-wrap">
                              <v-btn
                                class="search-button"
                                color="info"
                                :loading="arkmanMapping.coper.loading"
                                @click="searchCoperHotels"
                                block
                              >
                                <v-icon left>search</v-icon> Ara
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <!-- Seçili otel özeti -->
                          <div v-if="arkmanMapping.coper.selected" class="selected-summary">
                            Seçilen Coper Otel:
                            <span class="selected-summary-name">
                              {{ arkmanMapping.coper.selected.Isim }}
                            </span>
                          </div>

                          <!-- Sonuç listesi -->
                          <v-slide-y-transition>
                            <div v-if="showCoperList && coperPaged.length" class="list-wrapper">
                              <v-list dense>
                                <v-list-tile
                                  v-for="h in coperPaged"
                                  :key="h.Ref"
                                  @click="selectCoperHotel(h)"
                                  :class="[
                                    'hotel-item',
                                    {
                                      'hotel-item--selected':
                                        arkmanMapping.coper.selected &&
                                        arkmanMapping.coper.selected.Ref === h.Ref
                                    }
                                  ]"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title>{{ h.Isim }}</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>

                              <!-- Pagination -->
                              <v-layout row justify-space-between align-center class="pagination-row">
                                <span class="page-info">
                                  {{ coperPage }} / {{ coperMaxPage }}
                                </span>
                                <v-btn
                                  small
                                  flat
                                  class="next-button"
                                  @click="nextCoperPage"
                                  :disabled="coperPage >= coperMaxPage"
                                >
                                  İleri
                                  <v-icon right small>chevron_right</v-icon>
                                </v-btn>
                              </v-layout>
                            </div>
                          </v-slide-y-transition>
                        </v-card>
                      </v-flex>

                    </v-layout>

                    <!-- ========= EŞLEŞTİR BUTONU ========= -->
                    <v-layout row justify-center class="mt-4">
                      <v-btn
                        class="match-button"
                        color="success"
                        :disabled="
                          !arkmanMapping.ratehawk.selected ||
                          !arkmanMapping.coper.selected ||
                          arkmanMapping.saving
                        "
                        @click="mapSelectedHotels"
                      >
                        <v-icon left>link</v-icon>
                        Eşleştir
                      </v-btn>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
        </v-tab-item>

        <!-- ============== TAB 1: EŞLEŞTİRİLEN OTELLER ============== -->
        <v-tab-item>
          <v-layout row wrap>
            <v-flex xs12>
              <v-toolbar flat color="info" dark class="mapping-toolbar">
                <v-toolbar-title class="mapping-title">
                  Eşleştirilen Oteller
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="loadMappedHotels" :loading="mappedLoading">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-toolbar>
            </v-flex>

            <v-flex xs12>
              <v-card flat class="inner-card">
                <v-card-text>
                  <v-data-table
                    :headers="mappedHeaders"
                    :items="mappedHotels"
                    :loading="mappedLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <!-- Sol: Arkman Mapping Otel, Sağ: Coper Otel -->
                      <td class="text-xs-left">{{ props.item.RatehawkOtelAd }}</td>
                      <td class="text-xs-left">{{ props.item.CoperOtelAd }}</td>
                    </template>

                    <template slot="no-data">
                      <div class="text-xs-center pa-3">
                        Henüz eşleştirilmiş otel bulunamadı.
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>

      </v-tabs-items>

      <!-- ============ MODERN ONAY DİYALOĞU ============ -->
      <v-dialog v-model="confirmDialog.visible" max-width="480px">
        <v-card>
          <v-card-title class="headline">
            Eşleştirmeyi Güncelle
          </v-card-title>
          <v-card-text style="white-space: pre-line;">
            {{ confirmDialog.message }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="confirmDialog.visible = false">
              İptal
            </v-btn>
            <v-btn color="primary" flat @click="confirmDialogConfirm">
              Tamam
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from "../../../../api/auth";

export default {
  data() {
    return {
      activeTab: 0,

      loadingvmodel: false,
      snackbar: false,
      text1: null,

      credentials: null,

      // UI state
      showRatehawkList: true,
      showCoperList: true,

      // mapping tarafı
      arkmanMapping: {
        ratehawk: {
          searchText: "",
          loading: false,
          results: [],
          selected: null,
          page: 1,
          pageSize: 10
        },
        coper: {
          searchText: "",
          loading: false,
          results: [],
          selected: null,
          page: 1,
          pageSize: 10
        },
        saving: false
      },

      // eşleştirilmiş oteller tablosu
      mappedHotels: [],
      mappedLoading: false,
      mappedHeaders: [
        { text: "Arkman Mapping Otel", value: "RatehawkOtelAd" },
        { text: "Coper Otel", value: "CoperOtelAd" }
      ],

      // popup onay diyaloğu
      confirmDialog: {
        visible: false,
        message: "",
        payload: null
      }
    };
  },

  components: {
    snackbarcomp,
    loadingcomp
  },

  mounted() {
    this.credentials = JSON.parse(window.localStorage.getItem("credentials"));
  },

  watch: {
    activeTab(val) {
      // Eşleştirilen oteller tabına geçince otomatik yükle
      if (val === 1) {
        this.loadMappedHotels();
      }
    }
  },

  computed: {
    // Arkman (Ratehawk) paging
    ratehawkPage() {
      return this.arkmanMapping.ratehawk.page;
    },
    ratehawkMaxPage() {
      const len = this.arkmanMapping.ratehawk.results.length || 0;
      return len === 0 ? 1 : Math.ceil(len / this.arkmanMapping.ratehawk.pageSize);
    },
    ratehawkPaged() {
      const { page, pageSize, results } = this.arkmanMapping.ratehawk;
      const start = (page - 1) * pageSize;
      return results.slice(start, start + pageSize);
    },

    // Coper paging
    coperPage() {
      return this.arkmanMapping.coper.page;
    },
    coperMaxPage() {
      const len = this.arkmanMapping.coper.results.length || 0;
      return len === 0 ? 1 : Math.ceil(len / this.arkmanMapping.coper.pageSize);
    },
    coperPaged() {
      const { page, pageSize, results } = this.arkmanMapping.coper;
      const start = (page - 1) * pageSize;
      return results.slice(start, start + pageSize);
    }
  },

  methods: {
    searchRatehawk,
    searchCoperHotels,
    selectRatehawkHotel,
    selectCoperHotel,
    nextRatehawkPage,
    nextCoperPage,
    mapSelectedHotels,
    updateMapSelectedHotels,
    loadMappedHotels,

    confirmDialogConfirm() {
      const p = this.confirmDialog.payload;
      this.confirmDialog.visible = false;
      if (p) {
        this.updateMapSelectedHotels(p);
      }
    }
  }
};

// =====================
//   FONKSİYONLAR
// =====================

function searchRatehawk() {
  if (
    !this.arkmanMapping.ratehawk.searchText ||
    this.arkmanMapping.ratehawk.searchText.length < 3
  ) {
    this.text1 = "En az 3 karakter giriniz (Arkman Mapping).";
    this.snackbar = true;
    return;
  }

  this.arkmanMapping.ratehawk.loading = true;
  this.showRatehawkList = true;

  const params = {
    query: this.arkmanMapping.ratehawk.searchText,
    page: 1,
    pageSize: 50
  };

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/Search", {
      params: params,
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader()
      }
    })
    .then(
      response => {
        this.arkmanMapping.ratehawk.results = response.body || [];
        this.arkmanMapping.ratehawk.page = 1;
        this.arkmanMapping.ratehawk.loading = false;
      },
      () => {
        this.arkmanMapping.ratehawk.loading = false;
        this.text1 = "Service Unavailable - Arkman Mapping Search";
        this.snackbar = true;
      }
    );
}

function searchCoperHotels() {
  if (
    !this.arkmanMapping.coper.searchText ||
    this.arkmanMapping.coper.searchText.length < 2
  ) {
    this.text1 = "En az 2 karakter giriniz (Coper Otel).";
    this.snackbar = true;
    return;
  }

  this.arkmanMapping.coper.loading = true;
  this.showCoperList = true;

  const params = {
    searchTerm: this.arkmanMapping.coper.searchText
  };

  const c = this.credentials;

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/CoperHotels", {
      params: params,
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.coper.results = response.body || [];
        this.arkmanMapping.coper.page = 1;
        this.arkmanMapping.coper.loading = false;
      },
      () => {
        this.arkmanMapping.coper.loading = false;
        this.text1 = "Service Unavailable - CoperHotels";
        this.snackbar = true;
      }
    );
}

function selectRatehawkHotel(h) {
  this.arkmanMapping.ratehawk.selected = h;
  this.arkmanMapping.ratehawk.searchText = h.Name;
  this.showRatehawkList = false;
}

function selectCoperHotel(h) {
  this.arkmanMapping.coper.selected = h;
  this.arkmanMapping.coper.searchText = h.Isim;
  this.showCoperList = false;
}

function nextRatehawkPage() {
  if (this.ratehawkPage < this.ratehawkMaxPage) {
    this.arkmanMapping.ratehawk.page += 1;
  }
}

function nextCoperPage() {
  if (this.coperPage < this.coperMaxPage) {
    this.arkmanMapping.coper.page += 1;
  }
}

function mapSelectedHotels() {
  const rh = this.arkmanMapping.ratehawk.selected;
  const cp = this.arkmanMapping.coper.selected;

  if (!rh || !cp) {
    this.text1 = "Lütfen her iki taraftan da otel seçiniz.";
    this.snackbar = true;
    return;
  }

  const payload = {
    OtelRef: cp.Ref,
    OtelKod: cp.Kod,
    RatehawkKod: rh.Id,
    CoperOtelAd: cp.Isim,
    RatehawkOtelAd: rh.Name
  };

  const c = this.credentials;

  this.arkmanMapping.saving = true;
  this.loadingvmodel = true;

  this.$http
    .post(auth.API_URL + "api/RateHawkHotels/MapOtel", payload, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;

        const res = response.body || {};

        if (res.success === true && !res.conflictType) {
          this.text1 = res.message || "Eşleştirme kaydedildi.";
          this.snackbar = true;
          return;
        }

        if (res.success === true && res.isUpdated === false) {
          this.text1 = res.message || "Bu eşleştirme zaten mevcut.";
          this.snackbar = true;
          return;
        }

        // ÇAKIŞMA VARSA DİYALOG AÇ
        if (res.success === false && res.conflictType && res.existing) {
          const ex = res.existing;

          if (res.conflictType === "CoperAlreadyMapped") {
            const mevcutArkmanAd =
              ex.RatehawkOtelAd ||
              (this.arkmanMapping.ratehawk.selected &&
                this.arkmanMapping.ratehawk.selected.Name) ||
              ex.RatehawkKod;

            const msg =
              "Seçtiğiniz COPER otel daha önce başka bir Arkman Mapping oteli ile eşleştirilmiş.\n" +
              `Mevcut eşleşen Arkman Mapping Otel: ${mevcutArkmanAd}\n` +
              "Yeni eşleştirme ile güncellemek istiyor musunuz?";

            this.confirmDialog.message = msg;
            this.confirmDialog.payload = payload;
            this.confirmDialog.visible = true;
          } else if (res.conflictType === "RatehawkAlreadyMapped") {
            const mevcutCoperAd =
              ex.CoperOtelAd ||
              (this.arkmanMapping.coper.selected &&
                this.arkmanMapping.coper.selected.Isim) ||
              ex.OtelKod;

            const msg =
              "Seçtiğiniz Arkman Mapping otel daha önce başka bir COPER otel ile eşleştirilmiş.\n" +
              `Mevcut eşleşen COPER Otel: ${mevcutCoperAd}\n` +
              "Yeni eşleştirme ile güncellemek istiyor musunuz?";

            this.confirmDialog.message = msg;
            this.confirmDialog.payload = payload;
            this.confirmDialog.visible = true;
          }

          return;
        }

        this.text1 = "Bilinmeyen bir cevap alındı (MapOtel).";
        this.snackbar = true;
      },
      () => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;
        this.text1 = "Service Unavailable - MapOtel";
        this.snackbar = true;
      }
    );
}

function updateMapSelectedHotels(payload) {
  const c = this.credentials;

  this.arkmanMapping.saving = true;
  this.loadingvmodel = true;

  this.$http
    .post(auth.API_URL + "api/RateHawkHotels/UpdateMapOtel", payload, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;

        const res = response.body || {};
        if (res.success) {
          this.text1 = res.message || "Eşleştirme güncellendi.";
          this.snackbar = true;
          // Güncel listeyi de tazele
          if (this.activeTab === 1) {
            this.loadMappedHotels();
          }
        } else {
          this.text1 = "Eşleştirme güncellenemedi.";
          this.snackbar = true;
        }
      },
      () => {
        this.arkmanMapping.saving = false;
        this.loadingvmodel = false;
        this.text1 = "Service Unavailable - UpdateMapOtel";
        this.snackbar = true;
      }
    );
}

function loadMappedHotels() {
  if (!this.credentials) return;

  this.mappedLoading = true;
  const c = this.credentials;

  this.$http
    .get(auth.API_URL + "api/RateHawkHotels/Mappings", {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
        CariSirketNo: c.SirketKodu.toString(),
        CoperSirketNo: c.CoperSirketNo.toString(),
        MuhasebeSirketNo: c.MuhasebeSirketNo.toString()
      }
    })
    .then(
      response => {
        this.mappedHotels = response.body || [];
        this.mappedLoading = false;
      },
      () => {
        this.mappedLoading = false;
        this.text1 = "Service Unavailable - Mappings";
        this.snackbar = true;
      }
    );
}
</script>

<style scoped>
.mapping-wrapper {
  padding: 16px;
  background: #f5f7fb;
}

.mapping-card {
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.08);
}

.mapping-toolbar {
  border-radius: 0;
}

.mapping-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.inner-card {
  border-radius: 12px;
}

.column-card {
  padding: 8px 16px;
}

.column-header {
  font-weight: 600;
  opacity: 0.8;
}

.search-row {
  margin-bottom: 8px;
}

.search-input >>> .v-input__slot {
  border-radius: 8px;
}

.search-button-wrap {
  display: flex;
  align-items: center;
}

.search-button {
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(33, 150, 243, 0.4);
}

.list-wrapper {
  max-height: 280px;
  overflow-y: auto;
  margin-top: 4px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
}

.hotel-item {
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.08s ease;
}

.hotel-item:hover {
  background-color: #f3f4ff;
}

.hotel-item--selected {
  background-color: #e0f2fe;
  font-weight: 600;
}

.pagination-row {
  padding: 4px 12px 8px 12px;
  border-top: 1px solid #e5e7eb;
}

.page-info {
  font-size: 12px;
  color: #6b7280;
}

.next-button {
  text-transform: none;
  font-size: 12px;
}

.match-button {
  min-width: 200px;
  border-radius: 24px;
  text-transform: none;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.45);
}

.selected-summary {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.selected-summary-name {
  font-weight: 600;
  color: #111827;
}
</style>
